import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContentHeaderKey } from "src/app/constants/content-header";

import { AgentCompany } from "src/app/models/agent";
import { Contact } from "src/app/models/contacts";
import { CompanyResources } from "src/app/models/resource-link";
import { AgentCRMService } from "src/app/services/agent-crm.service";

@Component({
    selector: 'mwp-agent-resourcs-contacts ',
    templateUrl: './contacts.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentResourcesContactsComponent implements OnInit {
    public companySearchForm: FormGroup;
    public apiUrl = ContentHeaderKey.CounselorContacts;

    public contacts: Contact[];

    constructor(
        private agentCRMService: AgentCRMService,
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        this.agentCRMService.getCompanyResourcesByID().subscribe((response: CompanyResources) => {
            let companyID: number;
            let companyName: string;
            if (response) {
                this.contacts = response.contacts;
                companyID = response.companyID;
                companyName = response.companyName;
            }

            this.companySearchForm = this.formBuilder.group({
                companyName: [companyName, Validators.required],
                companyID: [companyID, Validators.required],
            });
        });
    }

    public getCompanyResources(company: AgentCompany) {
        this.agentCRMService.getCompanyResourcesByID(company).subscribe((response: CompanyResources) => {
            this.contacts = response.contacts;
        });
    }
}